import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=3209541f&scoped=true&"
import script from "./DialogComponent.vue?vue&type=script&lang=js&"
export * from "./DialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=3209541f&prod&lang=sass&scoped=true&"
import style1 from "./DialogComponent.vue?vue&type=style&index=1&id=3209541f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3209541f",
  null
  
)

export default component.exports